export default function TX01({ module }) {
    const item = module.items[0] || {};

    // Définir un style de fond si une image existe
    const backgroundStyle = item.picture1
        ? {
            backgroundImage: `url('${item.picture1}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }
        : {};

    return (
        <div className="w-full p-4">
            <section
                className="max-w-2xl mx-auto my-8 p-4 bg-white dark:bg-gray-900 rounded-lg shadow-lg"
                aria-labelledby="tx01-title"
            >
                {/* Titre */}
                {item.title && (
                    <h2
                        id="tx01-title"
                        className="text-3xl font-bold mb-4 text-gray-900 dark:text-white"
                    >
                        {item.title}
                    </h2>
                )}

                {/* Contenu textuel avec éventuellement un background image */}
                <div
                    className="relative rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-800 p-6 duration-300 hover:shadow-md"
                    style={backgroundStyle}
                    aria-label={item.alt_picture1 || ""}
                >
                    {/* Texte TinyMCE en HTML */}
                    {item.description && (
                        <div
                            className="dark:text-gray-900 text-white leading-relaxed bg-white bg-opacity-75 p-4 rounded-lg"
                            dangerouslySetInnerHTML={{ __html: item.description }}
                        ></div>
                    )}

                    {/* Icône Hover */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-50 transition-opacity duration-300">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-12 w-12 text-gray-800 dark:text-gray-200"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 10l4.553-4.553a1 1 0 00-1.414-1.414L13.586 8.586a2 2 0 01-2.828 0L5.861 3.861A1 1 0 004.447 5.275L9 10m6 4l4.553 4.553a1 1 0 01-1.414 1.414L13.586 15.414a2 2 0 00-2.828 0L5.861 20.139a1 1 0 01-1.414-1.414L9 14"
                            />
                        </svg>
                    </div>
                </div>
            </section>
        </div>
    );
}
